import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsUpShine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    viewBox="0 0 36 36" {...props}
  >
    <path
      stroke="#00D8CB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.783 5.338V3.75M11.636 11.691h-1.588M27.518 11.691H25.93M14.018 6.927l-1.123-1.123M23.548 6.927l1.123-1.123M13.875 18.58v12.17M22.004 18.58h3.37a3.194 3.194 0 0 1 3.12 3.882l-1.272 5.78a3.195 3.195 0 0 1-3.12 2.508M24.102 30.75h-14.7a1.597 1.597 0 0 1-1.597-1.597v-8.976c0-.882.715-1.597 1.597-1.597h4.488M22.004 18.58v-4.433a2.13 2.13 0 0 0-1.178-1.905l-.54-.27a2.66 2.66 0 0 0-3.55 1.15L13.89 18.58"
    />
  </svg>
);
export default SvgThumbsUpShine;
